/**
 * Floating gradient blobs + decorative sparkles for hero backgrounds.
 * Pure decoration — non-interactive, behind content.
 */
export default function FloatingDecor() {
  return (
    <div className="absolute inset-0 overflow-hidden pointer-events-none" aria-hidden="true">
      {/* Soft color blobs */}
      <div
        className="blob-decoration"
        style={{
          top: "5%",
          left: "-5%",
          width: "320px",
          height: "320px",
          background: "radial-gradient(circle, #155E75 0%, transparent 70%)",
          animationDelay: "0s",
        }}
      />
      <div
        className="blob-decoration"
        style={{
          top: "30%",
          right: "-8%",
          width: "380px",
          height: "380px",
          background: "radial-gradient(circle, #F59E0B 0%, transparent 70%)",
          animationDelay: "-5s",
          opacity: 0.35,
        }}
      />
      <div
        className="blob-decoration"
        style={{
          bottom: "10%",
          left: "30%",
          width: "260px",
          height: "260px",
          background: "radial-gradient(circle, #06B6D4 0%, transparent 70%)",
          animationDelay: "-9s",
          opacity: 0.3,
        }}
      />

      {/* Tiny floating shapes */}
      <svg
        className="absolute top-12 right-1/3 w-6 h-6 animate-float-slow text-[var(--brand-accent)]"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ animationDelay: "-2s" }}
      >
        <polygon points="12,2 14.5,9 22,9 16,13.5 18.5,21 12,16.5 5.5,21 8,13.5 2,9 9.5,9" />
      </svg>
      <svg
        className="absolute bottom-20 left-12 w-5 h-5 animate-float text-[var(--brand-sky)]"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ animationDelay: "-4s" }}
      >
        <circle cx="12" cy="12" r="10" />
      </svg>
      <svg
        className="absolute top-1/2 right-20 w-4 h-4 animate-float text-emerald-400"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ animationDelay: "-1s" }}
      >
        <rect x="4" y="4" width="16" height="16" rx="3" />
      </svg>
      <svg
        className="absolute top-32 left-1/2 w-3 h-3 animate-sparkle text-amber-400"
        viewBox="0 0 24 24"
        fill="currentColor"
      >
        <path d="M12 0l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" />
      </svg>
      <svg
        className="absolute bottom-1/4 right-1/4 w-3 h-3 animate-sparkle text-pink-400"
        viewBox="0 0 24 24"
        fill="currentColor"
        style={{ animationDelay: "-1s" }}
      >
        <path d="M12 0l3 9 9 3-9 3-3 9-3-9-9-3 9-3z" />
      </svg>
    </div>
  );
}
